// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"06329732","732":"4e40e346"}[chunkId] + ".chunk.js";
};